import React, { createContext, useState, useEffect } from 'react';
import io from 'socket.io-client';

export const SocketContext = createContext(null);

export const SocketContextProvider = ({ children }) => {
  const [socket, setSocket] = useState<any>(null);

  let hotelxSocketUrl: string;
  switch (process.env.REACT_APP_API_URL) {
    case 'dev-build':
      hotelxSocketUrl = 'https://hotelx-dev-api.ifca.io';
      break;
    case 'prod-build':
      hotelxSocketUrl = 'https://hotelxapi.hotelx.asia';
      break;
    case 'hms1-prod-build':
      hotelxSocketUrl = 'https://hotelx1api.hotelx.asia';
      break;
    case 'hms2-prod-build':
      hotelxSocketUrl = 'https://hotelx2api.hotelx.asia';
      break;
    case 'hms3-prod-build':
      hotelxSocketUrl = 'https://hotelx3api.hotelx.asia';
      break;
    case 'promenade-build':
      hotelxSocketUrl = 'https://hotelxapi-promenade.hotelx.asia';
      break;
    case 'promenade-uat-build':
      hotelxSocketUrl = 'https://hotelxapi-promenade-uat.hotelx.asia';
      break;
    case 'uat-build':
      hotelxSocketUrl = 'https://hotelx-uat-api.ifca.io';
      break;
    case 'asia-melaka-build':
      hotelxSocketUrl = 'https://hotelx-api.hotelxasiamelakahotel.com';
      break;
    case 'noble-melaka-build':
      hotelxSocketUrl = 'https://hotelx-api.hotelxnobleresorthotelmelaka.com';
      break;
    default:
      hotelxSocketUrl = 'http://localhost:8000';
      break;
  }

  useEffect(() => {
    const newSocket = io(hotelxSocketUrl, { transports: ['polling'], upgrade: false });

    if (newSocket !== null && newSocket !== undefined) {
      setSocket(newSocket);
    }

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return socket !== null && socket !== undefined ? (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  ) : (
    <>{children}</>
  );
};
